/* eslint-disable eqeqeq */
import httpUploader from '../../Utils/httpUploader';
// import http from '../../Utils/http';
import Swal from 'sweetalert2';

const Theme = {
  name: 'theme',
  state: {
    isDark: false,
    colors: {},
    logoo: '',
    Favicons: '',
    profileIcon:'',
  },
  reducers: {
    isDark(state, payload) {
      return { ...state, isDark: payload };
    },

    colors(state, payload) {
      return {
        ...state,
        colors: payload,
      };
    },

    logoo(state, payload) {
      return {
        ...state,
        logoo: payload,
      };
    },

    profileIcon(state, payload) {
      return {
        ...state,
        profileIcon: payload,
      };
    },

    Favicons(state, payload) {
      return {
        ...state,
        Favicons: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getTheme() {
      if (localStorage.getItem('savvyTheme')) {
        const storage = JSON.parse(localStorage.getItem('savvyTheme')).settings;
        dispatch.theme.Favicons(storage.favIcon);

        dispatch.theme.colors(storage.colors);
        dispatch.theme.logoo(storage.logo);
      } else {
        const id = JSON.parse(localStorage.getItem('userInfo'))?.org_id;
        try {
          // const response = await http.get(`savvy/settings/${id}`);
          const response = [];
          localStorage.setItem(
            'savvyTheme',
            JSON.stringify({
              org_id: id,
              settings: {
                logo: response.data.data.settings.logo, // Include the logo value in the request body
                favIcon: response.data.data.settings.favIcon, // Include the Favicons value in the request body
                colors: response.data.data.settings.colors,
              },
            })
          );
          dispatch.theme.colors(response.data.data.settings.colors);
          dispatch.theme.logoo(response.data.data.settings.logo);
          dispatch.theme.Favicons(response.data.data.settings.favIcon);
        } catch (error) {
          dispatch.theme.colors({
            mainColor: '#5A3B8C',
            secondryColor: '#92C344',
            background: 'E4E4EB',
            firstGradiant: 'rgba(146, 195, 68, 0.5)',
            mainFontColor: '#1D2939',
            secondFontColor: '#EEEEEE',
            thirdColor: '#92C344',
            thirdFontcolor: 'black',
            ForthColor: 'black',
            menueFontColor: '#8F90A6',
            navBg: 'rgba(255, 255, 255, 1)',
            menuBgNormal: 'rgba(246, 246, 246, 1)',
            menuBgHover: '#E4E4EB',
            menuBgActive: 'rgba(246, 246, 246, 1)',
          });
        }
      }
    },
    async postTheme(data, rootState) {
      const id = JSON.parse(localStorage.getItem('userInfo')).org_id;
      Swal.fire({
        title: 'Success',
        text: 'Your Theme has been Applied !',
        icon: 'success',
      });
      // Access the logo and Favicons state values from the state object
      const logoo = rootState.theme.logoo;
      const Favicons = rootState.theme.Favicons;
      // await http.post(`savvy/settings/`, {
      //   org_id: id,
      //   settings: {
      //     logo: logoo, // Include the logo value in the request body
      //     favIcon: Favicons, // Include the Favicons value in the request body
      //     colors: data,
      //   },
      // });
      localStorage.setItem(
        'savvyTheme',
        JSON.stringify({
          org_id: id,
          settings: {
            logo: logoo, // Include the logo value in the request body
            favIcon: Favicons, // Include the Favicons value in the request body
            colors: data,
          },
        })
      );
    },
    async changeColor(colors) {
      dispatch.theme.colors(colors);
    },

    async Upload({ file, foricon }) {
      const fileFormData = new FormData();
      fileFormData.append('file', file);
      const response = await httpUploader.post(`/utility/upload`, fileFormData);
      if (foricon == 'logo') {
        this.logoo(response.data.data);
      } else {
        this.Favicons(response.data.data);
      }
    },
  }),
};

export default Theme;
